import { put, takeLatest, call } from "redux-saga/effects"
import { loading, modal, toast, wallet } from "../types"
import lambdas from "../lambdas/apis"

export function* addAmountToWallet(action) {
    const { orderAmount, securityDeposit = 0, navigate, formName } = action.payload
    let status = 'danger', message = 'Something went Wrong!!!'
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const response = yield call(lambdas.wallet.addAmount, {}, {}, {}, { orderAmount, securityDeposit })
        if (response.data.code === 200) {
            yield put({ type: wallet.ADD_AMOUNT_TO_WALLET_SUCCESS, payload: response.data })
            navigate && navigate("/payment")
        } else {
            message = response.data.data.message
            yield put({ type: wallet.ADD_AMOUNT_TO_WALLET_FAILURE, payload: { message: 'Oops Something went wrong' } })
            yield put({ type: toast.SEND_TOAST, payload: { status, message } })
        }
    } catch (error) {
        message = error.message || `Something went Wrong!!!`
        yield put({ type: toast.SEND_TOAST, payload: { status, message } })
    }
    if (formName === "skipGst") {
        yield put({ type: modal.CLOSE_MODAL, payload: {} })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })

}

export function* getWalletDetails(action) {
    try {
        const { updateBalance } = action.payload
        const response = yield call(lambdas.wallet.getWalletDetails, {}, {}, { updateBalance })
        if (response.data.code === 200) {
            yield put({ type: wallet.GET_WALLET_DETAILS_SUCCESS, payload: response.data.data })
        } else {
            yield put({ type: wallet.GET_WALLET_DETAILS_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: wallet.GET_WALLET_DETAILS_FAILURE, payload: { message: error } })
    }
}


// use them in parallel
export default function* walletSaga() {
    yield takeLatest(wallet.ADD_AMOUNT_TO_WALLET_REQUEST, addAmountToWallet)
    yield takeLatest(wallet.GET_WALLET_DETAILS_REQUEST, getWalletDetails)

}
